import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchReferralGetLink, type TReferralGetLinkResponse } from '../../../repositories/cpd/v1/referral/get-link';
import { IThunkApi } from '../../../types/referrer/store';
import { setModalAction, setModalOpen } from '../../../slices';

export enum EGetReferralLinkRejectStatus {
  NOT_AUTHORIZED = 'not_authorized',
  ERROR = 'error',
}

export const getReferralLink = createAsyncThunk<string | EGetReferralLinkRejectStatus, 'copy' | 'share', IThunkApi>(
  'cpd/getReferralLink',
  async (action, _thunkApi) => {
    const {
      dispatch,
      extra: { httpApi, logger },
    } = _thunkApi;

    try {
      const res = (await fetchReferralGetLink({
        httpApi,
      })) as TReferralGetLinkResponse;

      if (res.statusCode === 400) {
        dispatch(setModalOpen());
        dispatch(setModalAction(action));

        return EGetReferralLinkRejectStatus.NOT_AUTHORIZED;
      }

      if (res.statusCode === 200) {
        return res.response.referralLink;
      }

      return EGetReferralLinkRejectStatus.ERROR;
    } catch (e) {
      logger.debug('Ошибка загрузки листинга рефералов', {
        message: e.message,
        domain: e.domain,
      });

      return EGetReferralLinkRejectStatus.ERROR;
    }
  },
);
